import { isNode } from '@pn/core/utils/env';
import { webStorageService } from '@pn/services/storage/webStorageService';
import { isNil } from 'lodash-es';

export const impersonationUserId = resolveImpersonationUserId();

/**
 * Resolves the impersonation user ID, allowing it to be set via a
 * `?impersonate=` URL param (persisted for subsequent loads, then stripped
 * from the address bar) in addition to the existing storage value.
 */
function resolveImpersonationUserId(): string | undefined {
  if (isNode()) return undefined;

  const storage = webStorageService('pn', 'session');

  const urlUserId = new URLSearchParams(window.location.search).get(
    'impersonate'
  );
  if (!isNil(urlUserId)) {
    storage.set('impersonate-user-id', urlUserId);
    removeUrlParam('impersonate');
    return urlUserId;
  }

  return storage.get<string>('impersonate-user-id');
}

function removeUrlParam(param: string): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState(null, '', url);
}

export function isImpersonating(): boolean {
  return !isNil(impersonationUserId);
}

export function stopImpersonating(): void {
  webStorageService('pn', 'session').unset('impersonate-user-id');
  window.location.reload();
}
